import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

//1. Collection Purchase Page
const getPurchaseCollectionData = async (bodyData) => {
  const res = await apiClient.post("/api/v9/myBinnys/getCollection", bodyData);
  return { data: res?.data?.data?.collectionData, totalCount: res?.data?.data?.totalCount, totalDesignCount: res?.data?.data?.totalDesignCount };
};

export const useGetPurchaseCollection = (bodyData) => {
  return useQuery({
    queryKey: ["purchaseCollection", bodyData],
    queryFn: () => getPurchaseCollectionData(bodyData),
    enabled: !!bodyData,
  });
};

//2. Collection Catgeory Purchase Page
const getPurchaseCollectionCategoryData = async (bodyData) => {
  const res = await apiClient.post("/api/v9/myBinnys/getCollectionCategory", bodyData);
  return { data: res?.data?.data?.categories, totalCount: res?.data?.data?.totalCount, collectionName: res?.data?.data?.collectionName };
};

export const useGetPurchaseCollectionCategory = (bodyData) => {
  return useQuery({
    queryKey: ["purchaseCollectionCategory", bodyData],
    queryFn: () => getPurchaseCollectionCategoryData(bodyData),
    enabled: !!bodyData,
  });
};

//3.Collection Designs
const getPurchaseCollectionDesignData = async ({ pageParam = 1, queryKey }) => {
  const [_key, bodyData] = queryKey;
  const res = await apiClient.post("/api/v9/myBinnys/getCollectionDesigns", {
    ...bodyData,
    page: pageParam,
  });

  const { designs, pagination } = res?.data?.data || {};

  return {
    data: designs || [],
    nextPage: pagination?.hasNextPage ? pageParam + 1 : undefined,
    totalPages: pagination?.totalPages,
    totalDesigns: pagination?.totalCount,
  };
};

export const useGetPurchaseCollectionDesign = (bodyData) => {
  return useInfiniteQuery({
    queryKey: ["purchaseCollectionDesigns", bodyData],
    queryFn: getPurchaseCollectionDesignData,
    enabled: !!bodyData,
    getNextPageParam: (lastPage) => lastPage?.nextPage,
  });
};
